import React from 'react'

import AppDetailsSection from '../UniversalSections/AppDetailsSection'

import { 
    useFormContext, 
    FormProvider
} from "react-hook-form"

function CollegeViewer(props){

    const methods = useFormContext()
    
    return (
        <>
            <FormProvider {...methods}>
                <AppDetailsSection name="college-details-sections" />
            </FormProvider>
        </>
    )

}

export default CollegeViewer